import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Call",
    children: /*#__PURE__*/_jsx("path", {
      d: "M11 27.52a6.96 6.96 0 0 1-4.95-2.05l-1.76-1.76a.996.996 0 0 1 0-1.41l5-5a.996.996 0 1 1 1.41 1.41L6.41 23l1.05 1.05c1.89 1.89 5.18 1.89 7.07 0l9.52-9.52a5.003 5.003 0 0 0 0-7.07L23 6.41 19.41 10a3.006 3.006 0 0 1-.12 4.12l-4.59 4.59a.996.996 0 1 1-1.41-1.41l4.59-4.59a.996.996 0 0 0 0-1.41l-.59-.59a.996.996 0 0 1 0-1.41l5-5a.996.996 0 0 1 1.41 0l1.76 1.76a7.007 7.007 0 0 1 0 9.9l-9.52 9.52a6.96 6.96 0 0 1-4.95 2.05Z"
    })
  }));
};